import { render, staticRenderFns } from "./DrawerDesktop.vue?vue&type=template&id=3234c185&scoped=true&"
import script from "./DrawerDesktop.vue?vue&type=script&lang=js&"
export * from "./DrawerDesktop.vue?vue&type=script&lang=js&"
import style0 from "./DrawerDesktop.vue?vue&type=style&index=0&id=3234c185&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3234c185",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItemGroup})
